<template>
  <div class="center-stat">
    <div class="center-stat-header">
      <div
        class="center-stat-header-item"
        v-for="item in statList"
        :key="item.type"
      >
        <img :src="item.background" />
        <div class="center-stat-header-item-type">{{ item.type }}</div>
        <div class="center-stat-header-item-total">
          <img :src="item.icon" />
          <span class="center-stat-header-item-total-num">{{
            item.total
          }}</span>
          <span>{{ item.unit }}</span>
        </div>
      </div>
    </div>
    <div class="center-stat-center">
      <div class="center-stat-center-text">
        <span class="center-stat-common download-map" @click="downloadMap">{{
          mapStat.text
        }}</span>
        <span class="go-back center-stat-common" v-if="back" @click="goBack"
          >返回上一层</span
        >
      </div>
      <div :id="mapStat.el" style="height: 500px; width: 1020px"></div>
    </div>
    <div class="center-stat-footer">
      <div
        class="center-stat-footer-item"
        v-for="item in chartList"
        :key="item.el"
      >
        <div class="center-stat-common">{{ item.text }}</div>
        <div :id="item.el" style="width: 466px; height: 240px"></div>
      </div>
    </div>
    <div
      :id="mapLargeStat.el"
      style="
        height: 2000px;
        width: 2000px;
        position: absolute;
        left: 0px;
        top: 0px;
        display: none;
      "
    ></div>
  </div>
</template>

<script>
import _ from 'lodash'
import echarts from 'echarts'
import moment from 'moment'
import { mapGetters } from 'vuex'
import {
  initMap,
  initBar,
  initLine,
  initLargeMap,
  getMonthDays,
} from '../echartOptions'
import { yesterdayDate, monthStartDate, monthEndDate } from '../constantDate'

export default {
  name: 'AllStatCenter',
  computed: {
    ...mapGetters({
      allOverview: 'statPage/allOverview',
      regionChildStat: 'statPage/regionChildStat',
      allGeoJson: 'statPage/allGeoJson',
      regionStat: 'statPage/regionStat',
      allChildrenArea: 'statPage/allChildrenArea',
    }),
    sid() {
      return this.$route.query.sid
    },
    regionId() {
      return +this.$route.query.regionId
    },
    regionName() {
      return this.$route.query.regionName
    },
    regionFullName() {
      return this.$route.query.regionFullName
    },
    regionCode() {
      return this.$route.query.regionCode
    },
    regionHasChild() {
      return _.includes(this.regionCode, '_full')
    },
    back() {
      return this.$route.query.back
    },
    overviewByRegion() {
      return _.get(
        this.allOverview,
        `${this.regionId}&${yesterdayDate}&${yesterdayDate}`,
        {}
      )
    },
    yesterdayChildStat() {
      const key = `${this.regionId}&${yesterdayDate}&${yesterdayDate}`
      return this.regionChildStat[key] || []
    },
    geoJsonByRegionCode() {
      return this.allGeoJson[this.regionCode]
    },
    // curYearfirst() {
    //   return `${moment().format('YYYY')}-01-31`
    // },
    // curYearEnd() {
    //   return `${moment().format('YYYY')}-12-31`
    // },
    // curYearStat() {
    //   const key = `${this.regionId}&${this.curYearfirst}&${this.curYearEnd}`
    //   return this.regionStat[key]
    // },
    curMonth() {
      return moment().format('YYYYMM')
    },
    curMonthStat() {
      const key = `${this.regionId}&${monthStartDate}&${monthEndDate}`
      return this.regionStat[key] || []
    },
    statList() {
      const {
        activeSchoolCount = 0,
        teacherTotal = 0,
        activeStudentTotal = 0,
        totalWorldCreationCount = 0,
      } = this.overviewByRegion
      return [
        {
          type: '学校总数',
          total: activeSchoolCount,
          background: require('@/assets/stat/background1.png'),
          icon: require('@/assets/stat/icon6.png'),
          unit: '所',
        },
        {
          type: '教师总数',
          total: teacherTotal,
          background: require('@/assets/stat/background2.png'),
          icon: require('@/assets/stat/icon7.png'),
          unit: '位',
        },
        {
          type: '学生总数',
          total: activeStudentTotal,
          background: require('@/assets/stat/background3.png'),
          icon: require('@/assets/stat/icon8.png'),
          unit: '人',
        },
        {
          type: '作品数',
          total: totalWorldCreationCount,
          background: require('@/assets/stat/background4.png'),
          icon: require('@/assets/stat/icon9.png'),
          unit: '份',
        },
      ]
    },
    mapStat() {
      let data = []
      if (this.regionHasChild) {
        _.forEach(this.yesterdayChildStat, value => {
          if (value[0]) {
            data.push({
              name: value[0].name,
              value: value[0].activeStudentTotal,
            })
          }
        })
      } else {
        data = [
          {
            name: this.regionName,
            value: this.overviewByRegion.activeStudentTotal,
          },
        ]
      }
      return initMap(
        '子区域激活学生分布（昨日）',
        'region-stat',
        this.yesterdayChildStat,
        this.regionFullName,
        _.sortBy(data, item => item.value),
        this.geoJsonByRegionCode
      )
    },
    chartList() {
      const { totalWorldCreationCount = 0 } = this.overviewByRegion
      const yesterdayChildStat = []
      _.forEach(this.yesterdayChildStat, value => {
        if (value[0]) {
          yesterdayChildStat.push({
            name: value[0].name,
            totalWorldCreationCount: value[0].totalWorldCreationCount,
          })
        }
      })
      const yesterdayChildStatByTotalWorldCreationCount = _.sortBy(
        yesterdayChildStat,
        item => -item.totalWorldCreationCount
      )
      let childRegions = []
      let regionWorksStatData = []
      if (this.regionHasChild) {
        _.forEach(yesterdayChildStatByTotalWorldCreationCount, ele => {
          childRegions.push(ele.name)
          regionWorksStatData.push(ele.totalWorldCreationCount)
        })
      } else {
        childRegions = [this.regionName]
        regionWorksStatData = [totalWorldCreationCount]
      }
      const worksGrowStatXdata = getMonthDays(moment().format('YYYYMM'))
      const worksGrowStatData = _.map(worksGrowStatXdata, item => {
        const curStat = _.find(
          this.curMonthStat,
          e =>
            e.dimTimeId ===
            _.toNumber(`${this.curMonth}${(item + '').padStart(2, 0)}`)
        )
        if (curStat) {
          return curStat.totalWorldCreationCount
        } else {
          return 0
        }
      })
      const regionWorksStat = initBar(
        '区域作品数量',
        'region-works-stat-small',
        childRegions,
        '单位: 个',
        [regionWorksStatData]
      )
      const worksGrowStat = initLine(
        '作品增长数量',
        'works-grow-stat-small',
        [],
        worksGrowStatXdata,
        '单位: 个',
        [worksGrowStatData],
        '单位: 日',
        true
      )
      return [regionWorksStat, worksGrowStat]
    },
    regionCodes() {
      return _.map(_.get(this.geoJsonByRegionCode, 'features', []), item => {
        return {
          name: item.properties.name,
          code: item.properties.adcode,
          childrenNum: item.properties.childrenNum,
        }
      })
    },
    regionChilds() {
      return _.map(this.allChildrenArea[this.regionId], item => {
        return {
          name: item.name,
          id: item.id,
        }
      })
    },
    mapLargeStat() {
      let data = []
      if (this.regionHasChild) {
        _.forEach(this.yesterdayChildStat, value => {
          if (value[0]) {
            data.push({
              name: value[0].name,
              value: value[0].activeStudentTotal,
            })
          }
        })
      } else {
        data = [
          {
            name: this.regionName,
            value: this.overviewByRegion.activeStudentTotal,
          },
        ]
      }
      return initLargeMap(
        '子区域激活学生分布（昨日）',
        'region-stat-large',
        this.yesterdayChildStat,
        this.regionFullName,
        _.sortBy(data, item => item.value),
        this.geoJsonByRegionCode
      )
    },
  },
  data() {
    return {
      largeMapUrl: '',
    }
  },
  methods: {
    goBack() {
      if (this.back) {
        this.$router.go(-1)
      }
    },
    init() {
      const { el, options, geoJson } = this.mapStat
      if (geoJson && geoJson.type) {
        this.initChart(el, options, geoJson)
        this.initLargeMap()
      }
      _.forEach(this.chartList, item => {
        this.initChart(item.el, item.options)
      })
    },
    initChart(el, options, geoJson) {
      const node = document.getElementById(el)
      const myChart = echarts.init(node)
      if (geoJson) {
        echarts.registerMap('MAP_NAME', geoJson)
      }
      myChart.clear()
      myChart.setOption(options)
      if (el === 'region-stat-large') {
        this.largeMapUrl = myChart.getDataURL({
          backgroundColor: '#ededed',
        })
      }
      if (geoJson) {
        myChart.on('click', params => {
          if (this.regionChilds.length > 1) {
            const { name, seriesName } = params
            const codeObj = _.find(this.regionCodes, item => item.name === name)
            const idObj = _.find(this.regionChilds, item => item.name === name)
            if (codeObj && idObj) {
              let code = codeObj.code
              if (codeObj.childrenNum > 0) {
                code = `${code}_full`
              }
              const id = idObj.id
              this.$router.push({
                name: 'AllStat',
                query: {
                  regionCode: code,
                  regionId: id,
                  regionFullName: `${seriesName}${name}`,
                  regionName: name,
                  back: 1,
                  sid: this.sid,
                },
              })
            } else {
              this.$message.warning('当前区域没有数据!')
            }
          } else {
            this.$message.warning('当前区域没有子区域!')
          }
        })
      }
    },
    initLargeMap() {
      const { el, options, geoJson } = this.mapLargeStat
      if (geoJson.type) {
        this.initChart(el, options, geoJson)
      }
    },
    downloadMap() {
      if (this.largeMapUrl) {
        const url = this.largeMapUrl
        const a = document.createElement('a')
        const event = new MouseEvent('click')
        a.download = this.regionFullName
        a.href = url
        a.dispatchEvent(event)
        this.$message.success('下载成功!')
      } else {
        this.$message.warning('下载失败，请稍后再试!')
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.center-stat {
  &-header {
    display: flex;
    justify-content: space-between;
    &-item {
      position: relative;
      & > div {
        position: absolute;
      }
      &-type {
        left: 18px;
        top: 18px;
        font-size: 18px;
        height: 18px;
      }
      &-total {
        top: 52px;
        left: 18px;
        font-size: 14px;
        display: flex;
        align-items: center;
        & > img {
          width: 50px;
          height: 50px;
        }
        &-num {
          font-size: 24px;
          margin-right: 4px;
          margin-left: 16px;
          margin-bottom: 10px;
          margin-top: 6px;
        }
      }
    }
  }
  &-center {
    margin-top: 20px;
    &-text {
      display: flex;
      justify-content: space-between;
      .download-map:hover {
        cursor: pointer;
        opacity: 0.8;
      }
      span {
        padding-right: 14px;
      }
      .go-back {
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: #106ffe;
        }
      }
    }
  }
  &-footer {
    display: flex;
    justify-content: space-between;
    &-item {
      width: 500px;
      height: 304px;
      background-color: #252a34;
      border: solid 1px #495482;
      box-sizing: border-box;
      border-radius: 4px;
      padding: 16px;
    }
  }
  &-common {
    height: 32px;
    font-size: 16px;
    line-height: 32px;
    padding-left: 14px;
    background-image: linear-gradient(
      0deg,
      #28466f 24%,
      rgba(40, 70, 111, 0.86) 38%,
      rgba(39, 54, 78, 0.5) 73%,
      #252a34 100%
    );
  }
}
</style>